import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()
  const previousPathname = useRef<string | null>(null)

  useEffect(() => {
    const previous = previousPathname.current
    previousPathname.current = pathname
    // Mobile coaching owns scrolling between its inline selection and details.
    // Entering from another page still starts at the top.
    const handheldPath = /^\/admin\/m\/coaching(?:\/|$)/
    if (handheldPath.test(pathname) && previous != null && handheldPath.test(previous)) return
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
